<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style="z-index: 0 !important"
    viewBox="0 0 1308 523"
    fill="white"
    :width="widthAttr"
    :height="heightAttr"
    overflow="visible"
  >
    <g filter="url(#filter0_dd_1008_1966)">
      <path
        d="M13 87C13 81.4771 17.4772 77 23 77H657.5H818.625H931.712C936.533 77 941.191 75.2589 944.83 72.0972L1014.11 11.9028C1017.75 8.74109 1022.4 7 1027.23 7H1292C1297.52 7 1302 11.4772 1302 17V502C1302 507.523 1297.52 512 1292 512H23C17.4772 512 13 507.523 13 502V87Z"
        class="fill-current-color"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1008_1966"
        x="0"
        y="0"
        width="1308"
        height="523"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="4" />
        <feGaussianBlur stdDeviation="3.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1008_1966" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1008_1966"
          result="effect2_dropShadow_1008_1966"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1008_1966"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ChooseModule',

    props: {
      width: {
        type: String,
        required: false,
      },

      height: {
        type: String,
        required: false,
      },

      size: {
        type: String,
        required: false,
      },
    },

    computed: {
      widthAttr() {
        if (this.height) return undefined;
        if (this.size) return this.size;
        return this.width || '1308px';
      },

      heightAttr() {
        if (this.width) return undefined;
        if (this.size) return this.size;
        return this.height || '523px';
      },
    },
  };
</script>
